/**
 * Created by christophe.gaon on 30/01/2017.
 */
import Vue from 'vue';
import tag from './tag-plugin';

/**
 * add tag plugin
 */
Vue.use(tag);
